export default __webpack_public_path__ + "static/media/Snowmelt_Runoff.9f920c35.webp";